/**
 * What counts as a control inside a selectable card or row.
 *
 * A click or a keypress that lands on one of these is for that control, not
 * for the card or row around it: the status pill on a map card, the Select
 * in a destination picker. OptionCard and ListRow share this so the two
 * never disagree about what a control is.
 */
export const INNER_CONTROL_SELECTOR =
  'button, input, select, textarea, a, [role="button"], [role="combobox"], [role="listbox"]';

/** Whether an event landed on a control inside `container`, not on it. */
export const onInnerControl = (
  container: HTMLElement,
  target: EventTarget | null
): boolean => {
  const control = (target as HTMLElement | null)?.closest?.(
    INNER_CONTROL_SELECTOR
  );
  return Boolean(control && control !== container);
};
